export const environment = {
  hmr: false,
  environment: 'production',
  countryLong: 'Malaysia',
  baseUrl: 'https://vendors.trysmartbite.com',
  ecommerceBaseUrl: 'https://trysmartbite.com',
  production: true,
  sentry: {enabled: true, url: 'https://54d855fb882649e4b3e449caa44650f4@o107235.ingest.sentry.io/5371643'},
  apiUrl: 'https://production-api.trysmartbite.com/api',
  apiUrlClient: 'https://production-api.trysmartbite.com/client-api',
  PUBLIC_FOOD_IMAGE_URL: 'https://images.trysmartbite.com/images/food',
  PUBLIC_SUPPLIERS_IMAGE_URL: 'https://images.trysmartbite.com/images/suppliers',
  PUBLIC_CHAINS_IMAGE_URL: 'https://images.trysmartbite.com/images/chains',
  API_UPLOADER_PATH: 'https://production-api.trysmartbite.com/api/uploader',
  paymentLink: 'https://www.onlinepayment.com.my/MOLPay/pay/trysmartbite/',
  version: 'VERSION',
  mapbox: 'pk.eyJ1IjoicmJlbGxvbiIsImEiOiJjamk3cmQ3emEwZWV3M2txcWRseDFocHRlIn0.-qhew7uVk17QImbhXTDwBA',
  zendesk: {
    enabled: false,
    key: '4bf27175-8b48-40cf-9027-6105cc6b4ae8'
  },
  segment: {enabled: false, id: 'mP8YuX13bjk4qpfuFi4xJRhU4DBnCEAH'},
  currency: {
    iso2: 'RM',
    iso3: 'MYR',
    country: 'MY',
    tax: 0.06
  },
  contact: {
    hotline: {
      raw1: '+60390784693',
      raw2: '+60390784693',
      pretty: '+60 3-9078 4693'
    },
    email: 'support@trysmartbite.com'
  },
  ga: {enabled: true, gtm: 'GTM-NQQKQCT'},
  setting: {
    "companyName": "Try Smart Bite Sdn Bhd",
    "companyNumber": "1180611-H",
    "bankAccountNumber": "28900021875",
    "bankName": "Hong Leong Bank",
    "swiftCode": "HLBBKLXXX",
    "companyAddress1": "Unit 23-11, Level 23, Tower A",
    "companyAddress2": "The Vertical Business Suite",
    "companyAddress3": "Bangsar, 59200, Kuala Lumpur",
    "taxNumber": "Service Tax Reg. No. W10-2104-32000043",
  },
  "smartLogistic":{
    "markup": 0.15, // 15% markup,
    "carCapTime": 30,
    "vanCapTime": 30,
    "4x4_suvCapTime": 30,
    "suvCapTime": 30,
    "bikeCapTime": 30
  }
};
